import {TranslateService} from '@ngx-translate/core';

import * as moment from 'moment';

import {Chart, ChartData} from '../../+postpayroll/check/key-metrics/key-metrics.interfaces';
import {Scss} from '../../shared/utils/scss';
import {DashboardBox} from '../dashboard.interfaces';

export class DashboardChartUtils {
  public static getGridOptions(): { x: number, y2: number } {
    return {
      x: 70,
      y2: 70
    };
  }

  public static getAxisOptions(): { interval: number, rotate: number } {
    return {
      interval: 0,
      rotate: 45
    };
  }

  public static monthSort(array: string[]): string[] {
    return array.sort((a: string, b: string) =>
      moment(a.split('-').join(' '), 'MMM YYYY', 'en').isAfter(moment(b.split('-').join(' '), 'MMM YYYY', 'en'))
        ? 1
        : -1);
  }

  public static formatCategories(categories: string[], translate: TranslateService): string[] {
    return categories.map((value: string) => {
      const category: string = value.split('-')[0];
      return translate.instant(category.charAt(0).toUpperCase() + category.slice(1).toLowerCase());
    });
  }

  public static setLinks(series: any[], chart: Chart, categories: string[]) {
    series.forEach((serie: any) => {
      serie.data = serie.data.map((value: number, index: number) => {
        return chart.data
          .find((chartData: ChartData) => chartData.value === value
            && chartData.category === serie.name
            && chartData.name === categories[index]) || value;
      });
    });
  }

  public static getTooltipPositionFunc(chartBox: DashboardBox) {
    return (position: [number, number]) => {
      if (chartBox.isClosed) {
        return [20, position[1] + 25];
      }
    };
  }

  public static standardColors(): string[] {
    return Scss.variable('chart-color-palette')
      .split(',')
      .map((color: string) => color.trim());
  }

  public static textColor(hex: string, darkColor = '#040508', lightColor = '#FFFFFF'): string {
    if (hex.indexOf('#') === 0) {
      hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
      return hex;
    }
    const r = parseInt(hex.slice(0, 2), 16),
      g = parseInt(hex.slice(2, 4), 16),
      b = parseInt(hex.slice(4, 6), 16);
    // https://stackoverflow.com/a/3943023/112731
    return (r * 0.299 + g * 0.587 + b * 0.114) > 186 ? darkColor : lightColor;
  }
}
